/* eslint-disable */
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';
import { notification } from 'antd';
import { handleOnPatientClick } from 'legacy/pages/PatientFile/module';

// URL functions
import {
  idtfPatientEnrollment,
  searchEnrolledPatients,
  fetchPatient,
  fetchAddresses,
  fetchInsurances,
  fetchEnrollPatientOverview,
  updateDuration,
} from 'legacy/containers/ApiUrls';

import { ROUTES, PATIENT_FILE_TABS } from 'legacy/constants'

// Constants Types
import {
  PATIENT_ENROLLMENT_REQUEST,
  PATIENT_ENROLLMENT_SUCCESS,
  PATIENT_ENROLLMENT_FAILURE,
  PATIENT_SEARCH_REQUEST,
  PATIENT_SEARCH_SUCCESS,
  PATIENT_SEARCH_FAILURE,
  PATIENT_SEARCH_CLEAR,
  PATIENT_SEARCH_IDENTIFIERS,
  PATIENT_SEARCH_ALL_DATA_CLEAR,
  FETCH_ENROLLED_PATIENT_REQUEST,
  FETCH_ENROLLED_PATIENT_SUCCESS,
  FETCH_ENROLLED_PATIENT_FAILURE,
  FETCH_ENROLLED_INSURANCE_SUCCESS,
  FETCH_ENROLLED_ADDRESS_SUCCESS,
  FETCH_ENROLLED_OVERVIEW_SUCCESS,
  NEW_PATIENT_ENROLL_FORM,
  UPDATE_DUATION_REQUEST,
  UPDATE_DUATION_SUCCESS,
  UPDATE_DUATION_FAILURE,
} from './types';

// ------------------------------------
// Actions
// ------------------------------------

export const patientEnrollmentRequest = () => ({
  type: PATIENT_ENROLLMENT_REQUEST,
});
export const patientEnrollmentSuccess = data => ({
  type: PATIENT_ENROLLMENT_SUCCESS,
  payload: data,
});
export const patientEnrollmentFailure = err => ({
  type: PATIENT_ENROLLMENT_FAILURE,
  payload: err,
});

export const updateDurationRequest = () => ({
  type: UPDATE_DUATION_REQUEST,
});
export const updateDurationSuccess = data => ({
  type: UPDATE_DUATION_SUCCESS,
  payload: data,
});
export const updateDurationFailure = err => ({
  type: UPDATE_DUATION_FAILURE,
  payload: err,
});

export const enrolledPatientRequest = () => ({
  type: FETCH_ENROLLED_PATIENT_REQUEST,
});
export const enrolledPatientSuccess = data => ({
  type: FETCH_ENROLLED_PATIENT_SUCCESS,
  payload: data,
});
export const enrolledInsuranceSuccess = data => ({
  type: FETCH_ENROLLED_INSURANCE_SUCCESS,
  payload: data,
});
export const enrolledAddressSuccess = data => ({
  type: FETCH_ENROLLED_ADDRESS_SUCCESS,
  payload: data,
});
export const enrolledOverviewSuccess = data => ({
  type: FETCH_ENROLLED_OVERVIEW_SUCCESS,
  payload: data,
});
export const enrolledPatientFailure = err => ({
  type: FETCH_ENROLLED_PATIENT_FAILURE,
  payload: err,
});

export const patientSearchRequest = () => ({
  type: PATIENT_SEARCH_REQUEST,
});
export const patientSearchSuccess = data => ({
  type: PATIENT_SEARCH_SUCCESS,
  payload: data,
});
export const patientSearchFailure = err => ({
  type: PATIENT_SEARCH_FAILURE,
  payload: err,
});

export const clearSearchResult = () => ({
  type: PATIENT_SEARCH_CLEAR,
});

export const clearAllData = () => ({
  type: PATIENT_SEARCH_ALL_DATA_CLEAR,
});

export const patientSearchIdentifierData = (data) => ({
  type: PATIENT_SEARCH_IDENTIFIERS,
  payload: data,
});

export const newPatientEnrollForm = (data) => ({
  type: NEW_PATIENT_ENROLL_FORM,
});

export const handlepatientEnrollment = (teamId, result, isEdit, patientId) => (
  dispatch,
  getState,
) => {
  dispatch(patientEnrollmentRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      dispatch(patientEnrollmentRequest());
      dispatch(idtfPatientEnrollment(teamId, result, isEdit, patientId)).then((res) => {
        if (res.status > 300) {
          if (res.status === 400) {
            res.json().then(body => {
              notification['error']({
                message: `API Error: ${body[0]}`,
                description: body[1] && body[1],
              });
            });
          } else {
            res.json().then(body => {
              notification['error']({
                message: `API Error: ${body.errors[0].title}`,
                description: body.errors[0].detail,
              });
            });
          }
        } else {
          res.json().then(body => {
            dispatch(handleOnPatientClick(true, true, { patientId: body.participant_id }, PATIENT_FILE_TABS.OVERVIEW))
          });
        }
      })
    })
    .then(data => {
      return dispatch(patientEnrollmentSuccess(data));
    })
    .catch(err => {
      return dispatch(patientEnrollmentFailure(err));
    });
};

export const fetchEnrollmentSearch = (formData) => (dispatch, getState) => {
  dispatch(clearSearchResult());
  dispatch(patientSearchIdentifierData(formData));
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }
  dispatch(patientSearchRequest());

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { profile, teams } = me.data;
      return Promise.all([
        dispatch(searchEnrolledPatients(teams[0].id, formData)),
      ]);
    })
    .then(data => {
      if (data[0].errors) {
        dispatch(patientSearchFailure(data[0].errors));
        notification['error']({
          description: data[0].errors[0].title || data[0].errors[0].detail,
        });
      } else {
        dispatch(patientSearchSuccess(data[0].patients))
      }
    }
    )
    .catch(err => {
      console.log('error in api', err)
      dispatch(patientSearchFailure(err));
    });
};

export const fetchEnrolledPatientData = (patientId) => (dispatch, getState) => {
  // dispatch(clearSearchResult());
  // dispatch(patientSearchIdentifierData(formData));
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }
  dispatch(enrolledPatientRequest());

  return promises
    .then(() => {
      return Promise.all([
        dispatch(fetchPatient(patientId)),
      ]);
    })
    .then(data => {
      dispatch(enrolledPatientSuccess(data && data[0] && data[0].profile))
    }
    )
    .then(() => {
      return Promise.all([
        dispatch(fetchAddresses(patientId)),
      ]);
    })
    .then(data => {
      dispatch(enrolledAddressSuccess(data && data[0]))
    }
    )
    .then(() => {
      return Promise.all([
        dispatch(fetchInsurances(patientId)),
      ]);
    })
    .then(data => {
      dispatch(enrolledInsuranceSuccess(data && data[0]))
    }
    )
    .then(() => {
      return Promise.all([
        dispatch(fetchEnrollPatientOverview(patientId)),
      ]);
    })
    .then(data => {
      dispatch(enrolledOverviewSuccess(data && data[0]))
    }
    )
    .catch(err => {
      console.log('error in api', err)
      dispatch(enrolledPatientFailure(err));
    });
};

export const updateDurationSerialNumber = (data) => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;
  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }
  dispatch(updateDurationRequest());

  const idtf_connection_id = getState().app && getState().app.dataSources && getState().app.dataSources.idtfEnrollments && getState().app.dataSources.idtfEnrollments.data[0].idtfConnectionId

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { profile } = me.data;
      return Promise.all([
        dispatch(updateDuration(idtf_connection_id, data)),
      ]);
    })
    .then(data => {
      dispatch(updateDurationSuccess(data))
    }
    )
    .catch(err => {
      console.log('error in api', err)
      dispatch(updateDurationFailure(err));
    });
};



// WEBPACK FOOTER //
// ./src/views/state/PatientEnrollment/PatientEnrollmentActions.js